import { codeExtractor, idExtractor } from '@utils/schema.utils';
import { schema } from 'normalizr';

import { Drone, StrategicDrone } from '@/types/utm/drone.types';
import { Fleet } from '@/types/utm/fleet.type';
import { FlyZone } from '@/types/utm/flyZone.types';
import { Pilot } from '@/types/utm/pilot.types';
import { FlyRoute, FlySection } from '@/types/utm/route.types';

import Entity = schema.Entity;

const pilotSchema: Entity<Pilot> = new Entity('pilots', {}, { idAttribute: codeExtractor<Pilot> });
const strategicDroneSchema: Entity<StrategicDrone> = new Entity(
  'strategicDrones',
  {},
  { idAttribute: idExtractor<StrategicDrone> },
);
const droneSchema: Entity<Drone> = new Entity(
  'drones',
  { pilots: [pilotSchema], strategicDrones: [strategicDroneSchema], strategicDrone: strategicDroneSchema },
  { idAttribute: codeExtractor<Drone> },
);
const fleetSchema: Entity<Fleet> = new Entity(
  'fleets',
  { pilots: [pilotSchema], drones: [strategicDroneSchema] },
  { idAttribute: codeExtractor<Fleet> },
);

const flyZoneSchema: Entity<FlyZone> = new Entity<FlyZone>('flyZones', {}, { idAttribute: codeExtractor<FlyZone> });

const flySectionSchema: Entity<FlySection> = new Entity(
  'flySections',
  { flyZones: [flyZoneSchema] },
  { idAttribute: codeExtractor<FlySection> },
);

const flyRouteSchema: Entity<FlyRoute> = new Entity(
  'flyRoutes',
  { sections: [flySectionSchema] },
  { idAttribute: codeExtractor<FlyRoute> },
);

const utmSchema = {
  drones: [droneSchema],
  strategicDrones: [strategicDroneSchema],
  pilots: [pilotSchema],
  fleets: [fleetSchema],
  flyRoutes: [flyRouteSchema],
  flySections: [flySectionSchema],
  flyZones: [flyZoneSchema],
};

export {
  pilotSchema,
  droneSchema,
  fleetSchema,
  strategicDroneSchema,
  flyZoneSchema,
  flySectionSchema,
  flyRouteSchema,
  utmSchema,
};
